import { logger } from 'common/services';

// Backs up sessionStorage, which can throw (Safari private mode, disabled storage), so the guard still
// holds within the page.
const promptedInMemory = new Set<string>();

const storageKey = (formKey: string, subjectId: string) => `forms.prompted:${formKey}:${subjectId}`;

/**
 * True the first time a form is claimed for a subject in this browser session, false on every repeat.
 * Claiming marks it, so call it only when the form is about to be requested.
 */
export const claimFormPrompt = (formKey: string, subjectId: string): boolean => {
  const key = storageKey(formKey, subjectId);
  if (promptedInMemory.has(key)) return false;
  promptedInMemory.add(key);
  try {
    if (window.sessionStorage.getItem(key)) return false;
    window.sessionStorage.setItem(key, '1');
  } catch (error) {
    logger.debug('[forms] sessionStorage unavailable for the prompted guard', {
      error: error instanceof Error ? error.name : 'unknown',
    });
  }
  return true;
};

export const resetFormPromptsForTests = () => {
  promptedInMemory.clear();
};
